



























// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';
import {ANALYTIC_CLICKS} from "@/services/Analytics";

@Component({
  name: 'DropupLayout',
  components: {
  },
})
export default class DropupLayout extends Vue {
  @Prop({ default: true })
  private hasButton!: boolean; // defines if it will have the "open drawer open and close" button or not

  @Prop({ default: false })
  private hiddenInClose!: boolean; // when closing, it will be totally hidden

  @Prop({ default: true })
  private openInHalf!: boolean; // will open in half of the screen size

  @Prop({ default: '#1A1346' }) // $color-primary in scss
  private dropUpColor !: string;

  @Prop({ default: '' })
  private pushOnClose !: string;

  private dropupOpen: boolean = false;

  private created() {
    this.$uiBus.on("dropup:open", this.openDrawer);
    this.$uiBus.on("dropup:close", this.closeDrawer);
  }

  private destroyed() {
    this.$uiBus.off("dropup:open", this.openDrawer);
    this.$uiBus.off("dropup:close", this.closeDrawer);
  }

  private openDrawerClick() {
    ANALYTIC_CLICKS.dropupOpen(this.$gtag);
    this.openDrawer();
  }

  private openDrawer() {
    this.dropupOpen = true;
  }

  private closeDrawer() {
    this.dropupOpen = false;
    this.$uiBus.emit("dropup:revertToInitialScreen");
    if (this.pushOnClose !== "") {
      this.$router.push({ name: this.pushOnClose });
    }
  }
}
